// extracted by mini-css-extract-plugin
export default {"container":"Iga83Q4hUQcnmcSpztSp"};